module.exports = __webpack_public_path__ + "assets/img/mnist.85899b27.png";